window.app = window.app || {};

window.app.communityBlock = {
  el: {
    section: document.querySelectorAll('.mt-community'),
    blocks: document.querySelectorAll('.mt-community__block'),
    carousel: document.querySelectorAll('.mt-community__carousel .swiper:not(.swiper-initialized)'),
    carouselNavigation: document.querySelectorAll('.mt-community__nav-btn')
  },
  config: [
    { 992: [200, 0, -100], 768: [100, 0, -50] },
    { 992: [290, 80, -150], 768: [150, 0, -50] },
    { 992: [210, 100, -30], 768: [30, 0, -30] },
    { 992: [260, 0, -180], 768: [60, 0, -60] },
    { 992: [240, 0, -400], 768: [30, 0, -60] },
    { 992: [120, 0, -250], 768: [40, 0, -40] },
    { 992: [150, 0, -480], 768: [80, 0, -140] },
    { 992: [205, 0, -420], 768: [20, 0, -180] },
    { 992: [120, 0, -110], 768: [90, 0, -90] }
  ],
  sliders: [],

  parallax: function() {
    const _this = this;
    if (_this.el.blocks.length === 0) return;

    window.onload = function() {
      lax.init();
      lax.addDriver('scrollY', () => window.scrollY);

      for (let i = 0; i < _this.config.length; i++) {
        lax.addElements(`.mt-community__block:nth-child(${i+1})`, {
          scrollY: {
            translateY: [
              ["elInY", "elCenterY", "elOutY"],
              { 768: _this.config[i]['768'], 992: _this.config[i]['992'] }
            ]
          }
        });
      }
    }
  },

  init: function() {
    const _this = this;

    if (_this.el.blocks.length > 0) _this.parallax();
    if (_this.el.carousel.length > 0) {
      const isElementOutViewport = el => {
        const rect = el.getBoundingClientRect();
        return rect.bottom < 0 || rect.right < 0 || rect.left > window.innerWidth || rect.top > window.innerHeight;
      };
      const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
      const preloadVideos = function(videos, i) {
        const video = videos[i];
        let videoLoaded = false;
        if (!video) return;
        video.addEventListener('loadedmetadata', () => {
          if (videos[i+1] && !videoLoaded) {
            preloadVideos(videos, i+1);
            videoLoaded = true;
          }
        }, { once: true });
        video.preload = 'metadata';
        setTimeout(() => {
          if (videoLoaded) return;
          videos[i+1] && preloadVideos(videos, i+1);
          videoLoaded = true;
        }, 3000);
      };
      const updateAutoplay = (s) => {
        const playingVidCount = [...s.section.querySelectorAll('.mt-community__slide video')].filter(video => isVideoPlaying(video)).length;
        if (playingVidCount === 0 && s.status === 'paused') {
          s.wrapper.classList.remove('manual');
          s.slider.autoplay.resume();
          s.slider.slideToLoop(s.slider.realIndex + 1);
          s.status = 'playing';
        }
      };

      // Community carousels
      _this.el.carousel.forEach(carouselWrapper => {
        const section = carouselWrapper.closest('.mt-community');
        const slider = new Swiper(carouselWrapper, {
          slidesPerView: 2,
          spaceBetween: 8,
          loop: true,
          direction: 'horizontal',
          freeMode: true,
          allowTouchMove: true,
          speed: Number(carouselWrapper.dataset.speed),
          a11y: false,
          grabCursor: true,
          preventClicks: false,
          preventClicksPropagation: false,
          autoplay: {
            delay: 10,
            pauseOnMouseEnter: false,
            disableOnInteraction: false
          },
          breakpoints: {
            460: {
              slidesPerView: 3
            },
            600: {
              slidesPerView: 4
            },
            850: {
              slidesPerView: 5
            },
            1000: {
              slidesPerView: 6,
              spaceBetween: 16,
              speed: Math.round(Number(carouselWrapper.dataset.speed) * 1.666)
            },
            1800: {
              slidesPerView: 7,
              spaceBetween: 16,
              speed: Math.round(Number(carouselWrapper.dataset.speed) * 1.833)
            }
          }
        });
        _this.sliders.push({
          section: section,
          wrapper: carouselWrapper,
          videosPreloaded: false,
          status: 'paused',
          slider: slider
        });
        carouselWrapper.classList.add('initialized')
      });

      // Additional events
      document.addEventListener('click', e => {
        if (!e.target.classList.contains('mt-community--carousel') && !e.target.closest('.mt-community--carousel')) {
          _this.sliders.forEach(s => updateAutoplay(s));
        }

        if (e.target.classList.contains('mt-community__video-overlay')) {
          const section = e.target.closest('.mt-community');
          const sliderObj = _this.sliders.find(e => e.section.id === section.id);
          const slide = e.target.closest('.mt-community__slide');
          const video = slide.querySelector('video');

          if (!sliderObj) return;
          if (isVideoPlaying(video)) {
            video.pause();
            slide.classList.remove('active');
            updateAutoplay(sliderObj);
          } else {
            video.play();
            slide.classList.add('active');
            sliderObj.slider.autoplay.pause();
            sliderObj.status = 'paused';
          }

          app.dl.customClick('', { type: 'video', location: 'Blazepod Community', position: slide.dataset.slideId })
        }
      });

      document.addEventListener('scroll', () => {
        _this.sliders.forEach(s => {
          const playingVid = [...s.section.querySelectorAll('.mt-community__slide video')].filter(video => isVideoPlaying(video));
          if (isElementOutViewport(s.section)) {
            playingVid.forEach(video => {
              video.closest('.mt-community__slide').classList.remove('active');
              video.pause();
            });
            updateAutoplay(s);
          }
          if (window.scrollY > (s.section.offsetTop - (1.5 * window.innerHeight)) && !s.videosPreloaded) {
            const carouselVideos = s.section.querySelectorAll('.mt-community__video-player');
            (carouselVideos.length > 0) && preloadVideos(carouselVideos, 0);
            s.videosPreloaded = true;
          }
        });
      });
    }
  }
}
window.app.communityBlock.init();